import React, { useState, useEffect } from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';

type Props = {
  onAddWidget?: () => void;
};

export default function AddWidgetsCard({ onAddWidget }: Props) {
  const [cardHover, setCardHover] = useState(false);
  const [btnHover, setBtnHover] = useState(false);
  const [toast, setToast] = useState(false);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(false), 2800);
    return () => clearTimeout(t);
  }, [toast]);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onAddWidget) {
      onAddWidget();
    } else {
      setToast(true);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        onMouseEnter={() => setCardHover(true)}
        onMouseLeave={() => setCardHover(false)}
        onClick={handleClick}
        style={{
          marginTop: 20,
          border: '2px dashed ' + (cardHover ? C.teal : C.line),
          borderRadius: 14,
          padding: '22px 22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
          background: cardHover ? '#fff' : 'transparent',
          cursor: 'pointer',
          transition: 'all 0.15s ease',
          fontFamily: F.family,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 40, height: 40, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
            <svg viewBox="0 0 24 24" width={28} height={28} fill="none" stroke={C.teal} strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
              <line x1="17.5" y1="14" x2="17.5" y2="21" />
              <line x1="14" y1="17.5" x2="21" y2="17.5" />
            </svg>
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: C.ink, margin: '0 0 2px' }}>Add widgets</div>
            <div style={{ fontSize: 12.5, color: C.sub, margin: 0 }}>
              Customize your dashboard: pin reports, KPIs, or any Vela watcher you want front and center.
            </div>
          </div>
        </div>
        <button
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          onClick={handleClick}
          style={{
            background: btnHover ? C.teal : C.ink,
            color: '#fff',
            border: 0,
            borderRadius: 10,
            padding: '9px 16px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily: F.family,
          }}
        >
          + Add widget
        </button>
      </div>

      {toast && (
        <div style={{
          position: 'fixed',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#0F172A',
          color: '#fff',
          padding: '10px 20px',
          borderRadius: 10,
          fontSize: 13,
          fontWeight: 500,
          zIndex: 999,
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          fontFamily: F.family,
        }}>
          Widget library coming soon
        </div>
      )}
    </div>
  );
}
